import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ActivePropertyProvider } from "@/context/ActivePropertyContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppLayout from "@/components/AppLayout";

import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import AcceptInvite from "@/pages/AcceptInvite";
import Dashboard from "@/pages/Dashboard";
import Properties from "@/pages/Properties";
import PropertyDetail from "@/pages/PropertyDetail";
import Users from "@/pages/Users";
import DailyReports from "@/pages/DailyReports";
import DailyReportForm from "@/pages/DailyReportForm";
import MonthlyReport from "@/pages/MonthlyReport";
import PayrollAnalysis from "@/pages/PayrollAnalysis";
import PayrollSheet from "@/pages/PayrollSheet";
import GuestComments from "@/pages/GuestComments";
import Employees from "@/pages/Employees";
import Invoices from "@/pages/Invoices";
import Documents from "@/pages/Documents";
import Accounting from "@/pages/Accounting";
import Handbook from "@/pages/Handbook";
import Portfolio from "@/pages/Portfolio";
import SharePage from "@/pages/SharePage";
import InvoiceApprovalPage from "@/pages/InvoiceApprovalPage";
import ReportConfig from "@/pages/ReportConfig";
import Chat from "@/pages/Chat";
import Requests from "@/pages/Requests";
import Tasks from "@/pages/Tasks";
import Maintenance from "@/pages/Maintenance";
import Housekeeping from "@/pages/Housekeeping";
import TimeClock from "@/pages/TimeClock";
import Schedule from "@/pages/Schedule";
import Kiosk from "@/pages/Kiosk";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <ActivePropertyProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/accept-invite" element={<AcceptInvite />} />
            <Route path="/share/:token" element={<SharePage />} />
            <Route path="/invoice-approval/:token" element={<InvoiceApprovalPage />} />
            <Route path="/kiosk/:token" element={<Kiosk />} />

            <Route
              element={
                <ProtectedRoute>
                  <AppLayout />
                </ProtectedRoute>
              }
            >
              <Route path="/" element={<Dashboard />} />
              <Route path="/properties" element={<Properties />} />
              <Route path="/properties/:id" element={<PropertyDetail />} />
              <Route path="/daily-reports" element={<DailyReports />} />
              <Route path="/daily-reports/new" element={<DailyReportForm />} />
              <Route path="/daily-reports/:propertyId/:date" element={<DailyReportForm />} />
              <Route path="/monthly-report" element={<MonthlyReport />} />
              <Route path="/payroll" element={<PayrollAnalysis />} />
              <Route path="/payroll-sheet" element={<PayrollSheet />} />
              <Route path="/time-clock" element={<TimeClock />} />
              <Route path="/schedule" element={<Schedule />} />
              <Route path="/guest-comments" element={<GuestComments />} />
              <Route path="/employees" element={<Employees />} />
              <Route path="/invoices" element={<Invoices />} />
              <Route path="/chat" element={<Chat />} />
              <Route path="/requests" element={<Requests />} />
              <Route path="/tasks" element={<Tasks />} />
              <Route path="/maintenance" element={<Maintenance />} />
              <Route path="/housekeeping" element={<Housekeeping />} />
              <Route path="/documents" element={<Documents />} />
              <Route path="/accounting" element={<Accounting />} />
              <Route path="/handbook" element={<Handbook />} />
              <Route path="/portfolio" element={<Portfolio />} />
              <Route path="/users" element={<Users />} />
              <Route path="/report-config" element={<ReportConfig />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        </ActivePropertyProvider>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
